export default __webpack_public_path__ + "9514ac4342ccc1f3018fbf3a529985fb.svg";